import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import DMS from "../Pages/DMS/DMS";
import Loader from "react-spinner-loader";
import { planning_routes_regs, lms_routes_regs, my_sop_mgmnt_regs, dmsdashboard, my_report_mgmnt_regs, resource_routes_regs, my_tasks_regs, region_routes_regs, agency_routes_regs, masterdatamgmnt_routes_regs, resource_entity_routes_regs, facility_routes_regs, masterresource_routes_regs, my_gis_mgmnt_regs, form_viewers, reportsMap, resourceallocation_routes_regs, situal_awaren } from "./DMSRoutes";
import RegistrationManagement from "../Pages/DMS/RegistrationManagement/RegistrationManagement";
import RegionManagement from "../Pages/DMS/RegionManagement/RegionManagement";
import AgencyManagement from "../Pages/DMS/AgencyManagement/AgencyManagement";
import TaskManagement from "../Pages/DMS/TaskManagement/TaskManagement";
import UserManagement from "../Pages/DMS/UserManagement/UserManagement";
import PrivateRoute from "./PrivateRoute";
import ResourceManagement from "../Pages/DMS/ResourceManagement/ResourceManagement";
import MasterDataManagement from "../Pages/DMS/MasterDataManagement/MasterDataManagement";
import FacilityManagement from "../Pages/DMS/FacilityManagement/FacilityManagement";
import MasterResourceManagement from "../Pages/DMS/MasterResourceManagement/MasterResourceManagement";
import MyTaskListManagement from "../Pages/DMS/MyTaskListManagement/MyTaskListManagement";
import GisManagement from "../Pages/DMS/GisManagement/GisManagement";
import ReportManagement from "../Pages/DMS/ReportManagement/ReportManagement";
import FormViewer from "../Pages/DMS/ReportManagement/FormViewer";
import FormRenderer from "../Pages/DMS/ReportManagement/FormRenderer";
import {
  getData
} from "../Services/Services";
import {
  getStoredFormTemplates, findPermissionsByUser
} from "../Services/EndPoints";
import FormViewerForm from "../Pages/DMS/ReportManagement/FormViewerForm";
import SOPExecutionManagement from "../Pages/DMS/GisManagement/SOPExecutionManagement";
import GISResourceManagement from "../Pages/DMS/GisManagement/GISResourceManagement";
import ReportBuilderManagement from "../Pages/DMS/GisManagement/ReportBuilderManagement";
import FormBuilder from "../Pages/DMS/ReportManagement/FormBuilder";
import SoPManagement from "../Pages/DMS/SOPManagement/SOPManagement";
import ContactManagement from "../Pages/DMS/ContactManagement/ContactManagement";
import DeploymentList from "../Pages/DMS/GisManagement/DeploymentList";
import { useKeycloak } from "@react-keycloak/web";
import UserTaskManagement from "../Pages/DMS/UserTaskManagement/UserTaskManagement";
import UserTaskForm from "../Pages/DMS/UserTaskManagement/UserTaskForm/UserTaskForm";
import AnimalShelter from "../Pages/DMS/Dashboard/AnimalShelter/AnimalShelter";
import UserProfile from "../Pages/UserProfile/UserProfile";
import StateDashboard from "../Pages/DMS/Dashboard/StateDashboard/StateDashboard";
import DMSDashboard from "../Pages/DMS/Dashboard/DMSDashboard/DMSDashboard";
import RTIncidentDashboard from "../Pages/DMS/GisManagement/RTIncidentDashboard";
import HumanLossForm from "../Pages/DMS/Dashboard/HumanLossDetails/HumanLossForm/HumanLossForm";
import DailyColdWaveForm from "../Pages/DMS/Dashboard/DailyColdWaveReport/DailyColdWaveForm";
// import HeatWaveFormA from "../Pages/DMS/Dashboard/HeatWaveFormatA/HeatWaveFormA";
// import HeatWaveFormC from "../Pages/DMS/Dashboard/HeatWaveFormatC/HeatWaveFormC";
// import HeatWaveEditFormB from "../Pages/DMS/Dashboard/HeatWaveFormatB/HeatWaveEditFormB";
import FireCommunityKitchenForm from "../Pages/DMS/Dashboard/FireCommunityKitchenReport/FireCommunityKitchenForm";
import DailyHeatWaveForm from "../Pages/DMS/Dashboard/DailyHeatWaveReport/DailyHeatWaveForm";
import DailyAffectedFloodReport from "../Pages/DMS/Dashboard/DailyAffectedFloodReport/DailyAffectedFloodReport";
import GisMapview from "../Pages/DMS/GisincidentManagement/GisMapview";
import IncidentManagementt from "../Pages/DMS/GisincidentManagement/IncidentManagementt";
import CreateIncident from "../Pages/DMS/Incidentmanagement/CreateIncident";
import CreateEvent from "../Pages/DMS/Incidentmanagement/CreateEvent";
import ResourceAssignAndDeploy from "../Pages/DMS/ResponseRelief/ResourceAssignAndDeploy";
import DeploymentResource from "../Pages/DMS/ResponseRelief/DeploymentResource";
import Chatbot from "../Pages/DMS/Chatbot/Chatbot";
import HumanLossDashboard from "../Pages/DMS/Dashboard/HumanLossDashboard/HumanLossDashboard";
import FireDashboard from "../Pages/DMS/Dashboard/FireDashboard/FireDashboard";
import HeatWaveDashboard from "../Pages/DMS/Dashboard/HeatWaveDashboard/HeatWaveDashboard";
import ColdWaveDashboard from "../Pages/DMS/Dashboard/CodlWaveDashboard/ColdWaveDashboard";
import navLinks from "../JsonData/navLinksData";
import DailyColdWaveReport from "../Pages/DMS/Dashboard/DailyColdWaveReport/DailyColdWaveReport";
import DailyHeatWaveReport from "../Pages/DMS/Dashboard/DailyHeatWaveReport/DailyHeatWaveReport";
import HumanLossReport from "../Pages/DMS/Dashboard/HumanLossReport/HumanLossReport";
import FireIncidentReport from "../Pages/DMS/Dashboard/FireIncidentReport/FireIncidentReport";
import UserActivityManagement from "../Pages/DMS/UserManagement/UserActivity/UserActivityManagement";
import FireCommunityKitchenRegForm from "../Pages/DMS/Dashboard/FireCommunityKitchenReport/FireCommunityKitchenRegForm";
import CommunityKitchen from "../Pages/DMS/Dashboard/CommunityKitchen/CommunityKitchen";
import FloodReliefCamp from "../Pages/DMS/Dashboard/FloodReliefCamp/FloodReliefCamp";

const Router = () => {
  const [formViewerLinks, setFormViewerLinks] = useState([]);
  const [permissionArr, setPermissionArr] = useState(null);
  const [pemrssionLoaded, isPermissionLoaded] = useState(false);
  const [loader, setLoader] = useState(false);
  const { keycloak, initialized } = useKeycloak()
  
  useEffect(() => {
    if (keycloak.authenticated) {
      getPermissionList();
      addReportMenu();
    }
  }, [keycloak.authenticated])

  const getPermissionList = async () => {
    var permissionArr = await getData(findPermissionsByUser);
    setPermissionArr(permissionArr)
  };

  const getAdministrativeActIndexComponent = () => {
    let componentArr = {
      "2_0": <MasterDataManagement />,
      "6_1": <RegionManagement />,
      "10_2": <AgencyManagement />,
      "37_3": <UserManagement />,
      "18_4": <MasterDataManagement />,
      "38_5": <ReportManagement />,
      "39_6": <FormBuilder />
    };
    let data = [];
    permissionArr.forEach(function (permission) {
      if (permission.parent_id != null && permission.parent_id == 1) {
        data.push(permission);
      }
    });
    data = data.sort((a, b) => {
      if (a.menu_index < b.menu_index) {
        return -1;
      }
    });
    if (data.length > 0) {
      return componentArr[data[0]['id'] + '_' + data[0]['menu_index']]
    }
    else {
      return null;
    }
  }

  const getPlanningIndexComponent = () => {
    let componentArr = {
      "22_0": <ContactManagement />,
      "34_1": <FacilityManagement />,
      "35_2": <ResourceManagement />,
      "36_3": <SoPManagement />
    };
    let data = [];
    permissionArr.forEach(function (permission) {
      if (permission.parent_id != null && permission.parent_id == 26) {
        data.push(permission);
      }
    });
    data = data.sort((a, b) => {
      if (a.menu_index < b.menu_index) {
        return -1;
      }
    });
    if (data.length > 0) {
      return componentArr[data[0]['id'] + '_' + data[0]['menu_index']]
    }
    else {
      return null;
    }
  }

  const addReportMenu = async () => {
    var data = await getData(getStoredFormTemplates);
    let form_viewer_links = [];
    data.forEach(function (dataElems) {
      form_viewer_links.push(
        dataElems.form_name
      );
    });
    setFormViewerLinks(form_viewer_links);
  };
// Add this helper function to map routes to components

const getIndexComponent = (routePath) => {
  const routeMap = {
    // Dashboards
    "dist-dashboard": <StateDashboard />,
    "humanloss-dashboard": <HumanLossDashboard />,
    "fire-dashboard": <FireDashboard />,
    "heatwave-dashboard": <HeatWaveDashboard />,
    "coldwave-dashboard": <ColdWaveDashboard />,
    "dmsdashboard": <DMSDashboard />,
    "incidentdashboard": <RTIncidentDashboard />,
    
    // Reports
    "affected-floodreport": <DailyAffectedFloodReport />,
    "partiallyaffected-floodreport": <DailyAffectedFloodReport />,
    "dailyfloodreport": <DailyAffectedFloodReport />,
    "reporting-status": <ReportManagement />,
    "affected-report": <DailyAffectedFloodReport />,
    "partiallyaffected-report": <DailyAffectedFloodReport />,
    "statefloodreport": <DailyAffectedFloodReport />,
    "misdist-report": <ReportManagement />,
    "human-loss-report": <HumanLossReport />,
    "mis-human-loss-report": <ReportManagement />,
    "fireincident-report": <FireIncidentReport />,
    "mis-fire-report": <ReportManagement />,
    "fire-community-kitchen-report": <FireCommunityKitchenForm />,
    "fire-wave-reporting-status": <ReportManagement />,
    "heat-wave-report": <DailyHeatWaveReport />,
    "heat-wave-misreport": <ReportManagement />,
    "heat-wave-reporting-status": <ReportManagement />,
    "dr-cold-wave": <DailyColdWaveReport />,
    "misdist-coldwave-report": <ReportManagement />,
    "cold-wave-reporting-status": <ReportManagement />,
    "community-kitchen": <CommunityKitchen />,
    "fl-camp": <FloodReliefCamp />,
    "animal-shelter": <AnimalShelter />,
    
    // My Tasks
    "my-tasks": <MyTaskListManagement />,
    "view-usertask": <UserTaskManagement />,
    
    // Administrative Activities
    "masterdata-table": <MasterDataManagement />,
    "region-list": <RegionManagement />,
    "agency-list": <AgencyManagement />,
    "users": <UserManagement />,
    "roles": <UserManagement />,
    "master-resource": <MasterResourceManagement />,
    "user-activity": <UserActivityManagement />,
    
    // Planning
    "view-contact": <ContactManagement />,
    "facility-mgmt": <FacilityManagement />,
    "resource-list": <ResourceManagement />,
    "view-sop": <SoPManagement />,
    "view-task": <TaskManagement />,
    "create-sop": <SoPManagement />,
    "execute-sops": <SOPExecutionManagement />,
    "Sop-instance-list": <SOPExecutionManagement />,
    
    // Situational Awareness/GIS
    "situation-awareness": <GisMapview />,
    "incident-management": <IncidentManagementt />,
    "create-event": <CreateEvent />,
    "create-incidentpage": <CreateIncident />,
    
    // Response & Relief
    "resource-assign-list": <ResourceAssignAndDeploy />,
    "deployment-resource": <DeploymentResource />,
    
    // Other routes
    "gismanagement": <GisManagement />,
    "sopexecution": <SOPExecutionManagement />,
    "resources": <GISResourceManagement />,
    "reportmanagement": <ReportManagement />,
    "response-relief": <DeploymentList />,
    "reportbuilder": <ReportBuilderManagement />,
    "static": <MyTaskListManagement />,
    "userProfile": <UserProfile />,
    "Chatbot": <Chatbot />,
    
    // Form routes
    "human-loss/registration-form": <HumanLossForm />,
    "daily-cold-wave/registration-form": <DailyColdWaveForm />,
    "daily-heat-wave/registration-form": <DailyHeatWaveForm />,
    "fire-community-kitchen/registration-form": <FireCommunityKitchenForm />,
  };

  return routeMap[routePath]; // Default fallback
};
// Add this function alongside your other helper functions
const getFirstAccessibleChild = (navItem) => {
  if (!navItem.children || navItem.children.length === 0) {
    return getIndexComponent(navItem.to);
  }
  // Recurse into first child that has a valid component
  for (const child of navItem.children) {
    const component = getFirstAccessibleChild(child);
    if (component) return component;
  }
  return null;
};
const getFirstAccessibleRoute = () => {
  if (!permissionArr) return null;

  const userPermissionIds = permissionArr.map((p) => p.id);

  for (const navItem of navLinks) {
    if (navItem.children && navItem.children.length > 0) {
      for (const child of navItem.children) {

        // Skip children with no allowedPermissionIds
        if (!child.allowedPermissionIds || child.allowedPermissionIds.length === 0) continue;

        const childAccess = child.allowedPermissionIds.some((id) =>
          userPermissionIds.includes(id)
        );

        if (childAccess) {
          const childRoute = child.to.replace(/^\.\.\//, "");
          const component = getIndexComponent(childRoute);
          if (component) return component;
        }

        // ✅ Check grandchildren (3rd level)
        if (child.children && child.children.length > 0) {
          for (const grandchild of child.children) {
            if (!grandchild.allowedPermissionIds || grandchild.allowedPermissionIds.length === 0) continue;

            const grandchildAccess = grandchild.allowedPermissionIds.some((id) =>
              userPermissionIds.includes(id)
            );

            if (grandchildAccess) {
              const grandchildRoute = grandchild.to.replace(/^\.\.\//, "");
              const component = getIndexComponent(grandchildRoute);
              if (component) return component;
            }
          }
        }
      }
    } else {
      if (!navItem.allowedPermissionIds || navItem.allowedPermissionIds.length === 0) continue;

      const hasAccess = navItem.allowedPermissionIds.some((id) =>
        userPermissionIds.includes(id)
      );

      if (hasAccess) {
        const component = getIndexComponent(navItem.to);
        if (component) return component;
      }
    }
  }

  return null;
};

  const get = async () => {
    var data = await getData(getStoredFormTemplates);
    let form_viewer_links = [];
    data.forEach(function (dataElems) {
      form_viewer_links.push(
        dataElems.form_name
      );
    });
    setFormViewerLinks(form_viewer_links);
  };

  return (
    <Routes>
      {permissionArr != null && <Route path="/" element={<DMS />}>
<Route
  index
  element={
    <PrivateRoute>
      {getFirstAccessibleRoute() ?? (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h3>No accessible modules found.</h3>
          <p>
            Please contact your administrator to assign the required permissions.
          </p>
        </div>
      )}
    </PrivateRoute>
  }
/>
        
        <Route path="/userProfile" element={<PrivateRoute><UserProfile /></PrivateRoute>} />
        
        <Route
          path="static"
          element={
            <PrivateRoute>
              <MyTaskListManagement />
            </PrivateRoute>
          }
        />
        
        {/* Rest of your routes remain exactly the same */}
        <Route path="users" >
          <Route index element={<UserManagement />} />
          {lms_routes_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>
        
        <Route path="resource-assign-list" >
          <Route index element={<ResourceAssignAndDeploy />} />
          {resourceallocation_routes_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>
        
        <Route path="/resource-assign-list/deployment-resource">
          <Route index element={<DeploymentResource />} />
        </Route>

        <Route path="resource-list" element={<RegistrationManagement />}>
          <Route index element={<ResourceManagement />} />
          {resource_routes_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>

        <Route path="master-resource" element={<RegistrationManagement />}>
          <Route index element={<MasterResourceManagement />} />
          {masterresource_routes_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>
        
        <Route path="dist-dashboard" element={<RegistrationManagement />}>
          <Route index element={<StateDashboard />} />
          {dmsdashboard.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>
        
        <Route path="reports" element={<RegistrationManagement />}>
          <Route index element={<DailyAffectedFloodReport />} />
          {reportsMap.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>

        <Route path="my-tasks" element={<MyTaskListManagement />}>
          <Route index element={<MyTaskListManagement />} />
          {my_tasks_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>
        
        <Route path="situation-awareness" element={<GisMapview />}>
          {situal_awaren.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>

        <Route path="reportbuilder">
          <Route index element={<ReportBuilderManagement />} />
        </Route>
        
        <Route path="dist-dashboard/incidentdashboard">
          <Route index element={<RTIncidentDashboard />} />
        </Route>

        <Route path="region-list">
          <Route index element={<RegionManagement />} />
          {region_routes_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>
        
        <Route path="agency-list">
          <Route index element={<AgencyManagement />} />
          {agency_routes_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>
        
        <Route path="masterdata-table">
          <Route index element={getAdministrativeActIndexComponent()} />
          {masterdatamgmnt_routes_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>

        <Route path="planning">
          <Route index element={getPlanningIndexComponent()} />
          {planning_routes_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>

        <Route path="facility-mgmt">
          <Route index element={<FacilityManagement />} />
          {facility_routes_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>
        
        <Route path="gismanagement">
          <Route index element={<GisManagement />} />
          {my_gis_mgmnt_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>

        <Route path="/my-tasks/view-usertask">
          <Route index element={<UserTaskManagement />} />
        </Route>
        
        <Route path="/situation-awareness/incident-management">
          <Route index element={<IncidentManagementt />} />
        </Route>
        
        <Route path="/situation-awareness/create-event">
          <Route index element={<CreateEvent />} />
        </Route>
       
        <Route path="/situation-awareness/create-incidentpage">
          <Route index element={<CreateIncident />} />
        </Route>

        <Route path="/my-tasks/create-usertask">
          <Route index element={<UserTaskForm />} />
        </Route>

        <Route path="response-relief">
          <Route index element={<DeploymentList />} />
        </Route>

        <Route path="sopexecution">
          <Route index element={<SOPExecutionManagement />} />
        </Route>

        <Route path="resources">
          <Route index element={<GISResourceManagement />} />
        </Route>
        
        <Route path="dmsdashboard">
          <Route index element={<DMSDashboard />} />
          {dmsdashboard.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>

        <Route path="reportmanagement">
          <Route index element={<ReportManagement />} />
          {my_report_mgmnt_regs.map(({ name, component }, i) => (
            <Route
              key={i}
              path={name}
              element={<PrivateRoute>{component}</PrivateRoute>}
            />
          ))}
        </Route>

        {my_report_mgmnt_regs.map(({ name, component }, i) => (
          <Route
            key={i}
            path={name}
            element={<PrivateRoute>{component}</PrivateRoute>}
          />
        ))}

        <Route path="report-view/:formName">
          <Route index element={<PrivateRoute><FormViewer /></PrivateRoute>} />
        </Route>
        
        <Route path="create-form-view/:formName">
          <Route index element={<PrivateRoute><FormRenderer /></PrivateRoute>} />
        </Route>
        
        <Route path="/human-loss/registration-form">
          <Route index element={<HumanLossForm />} />
        </Route>
        
        <Route path="/daily-cold-wave/registration-form">
          <Route index element={<DailyColdWaveForm />} />
        </Route>
        
        <Route path="/daily-heat-wave/registration-form">
          <Route index element={<DailyHeatWaveForm />} />
        </Route>

        <Route path="/fire-community-kitchen/registration-form">
          <Route index element={<FireCommunityKitchenForm />} />
        </Route>

      </Route>}
    </Routes>
  );
};

export default Router;